export function checkBooleanParams(value, condition) {
    return typeof value === 'string'
        ? value === condition.toString()
        : value === condition;
}
